import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Welcome from './components/pages/Welcome';
import Context from './components/pages/Context';
import Alignment from './components/pages/Alignment';
import Insights from './components/pages/Insights';
import Roadmap from './components/pages/Roadmap';
import Summary from './components/pages/Summary';

function App() {
  const [currentPage, setCurrentPage] = useState('welcome');
  const [completedPages, setCompletedPages] = useState(new Set());
  const [scores, setScores] = useState({});
  const [formData, setFormData] = useState({
    companyName: '',
    industry: '',
    employees: '',
    preparedBy: '',
    priorities: '',
    friction: '',
    concerns: [],
    incidents: ''
  });

  const handleSetPage = (pageId) => {
    setCompletedPages(prev => new Set([...prev, currentPage]));
    setCurrentPage(pageId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    // Basic body styling mapped from original CSS
    document.body.className = 'bg-gradient-to-br from-[#f5f7fa] to-[#e4e8ec] min-h-screen text-[#2C3E50] font-sans antialiased pb-10';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header 
        currentPage={currentPage} 
        setPage={handleSetPage} 
        completedPages={completedPages} 
      />
      
      <main className="flex-1 w-full max-w-5xl mx-auto p-4 md:p-6 mt-4">
        {currentPage === 'welcome' && <Welcome setPage={handleSetPage} />}
        {currentPage === 'context' && <Context setPage={handleSetPage} formData={formData} setFormData={setFormData} />}
        {currentPage === 'alignment' && <Alignment setPage={handleSetPage} scores={scores} setScores={setScores} />}
        {currentPage === 'insights' && <Insights setPage={handleSetPage} scores={scores} />}
        {currentPage === 'roadmap' && <Roadmap setPage={handleSetPage} scores={scores} />}
        {currentPage === 'summary' && <Summary formData={formData} scores={scores} />}
      </main>

      <footer className="bg-[#244C86] text-white text-center p-4 text-xs mt-auto print:hidden">
        © {new Date().getFullYear()} Visual Edge IT — Total Technology Alignment Tool
      </footer>
    </div>
  );
}

export default App;